import React, { useContext, useState } from "react";
import Context from "./CommonContext";

function CommonProvider(props) {
  const defaultFontSize = 16;
  const [fontSize, setFontSize] = useState(defaultFontSize);

  const changeFontSize = (change) => {
    setFontSize((prevSize) =>
      prevSize + change < 25 
    ? prevSize + change : 25
    );
  };

  const changeFontSizeMinus = (change) => {
    setFontSize((prevSize) =>
      prevSize - change > 10 ? prevSize - change : 10
    );
  };

  const resetFontSize = () => {
    setFontSize(defaultFontSize);
  };

  // http://192.9.211.183:89/api/GetBanner 
  // const { href } = window.location;

  //  Live
  // const [BaseURL, setBaseURL] = useState(
  //   href.indexOf("http://jmmf.cmots.com") !== -1
  //     ? "https://jmmfapi.jmfinancialmf.com/api/"
  //     : "https://jmmfapi.jmfinancialmf.com/api/"
  // );
  // const [BaseURLShare, setBaseURLShare] = useState(
  //   href.indexOf("http://jmmf.cmots.com") !== -1
  //     ? "https://jmmfapi.jmfinancialmf.com/api/"
  //     : "https://jmmfapi.jmfinancialmf.com/api/"
  // ); 

  //Prepod 
  //   const [BaseURL, setBaseURL] = useState(
  //   href.indexOf("http://jmmf.cmots.com") !== -1
  //     ? "https://jmmfpreprodapi.jmfinancialmf.com/api/"
  //     : "https://jmmfpreprodapi.jmfinancialmf.com/api/"
  // );
  // const [BaseURLShare, setBaseURLShare] = useState(
  //   href.indexOf("http://jmmf.cmots.com") !== -1
  //     ? "https://jmmfpreprodapi.jmfinancialmf.com/api/"
  //     : "https://jmmfpreprodapi.jmfinancialmf.com/api/"
  // ); 


//live server branch named sahil

  // UAT
  // const [BaseURL, setBaseURL] = useState(
  //   href.indexOf("http://jmmf.cmots.com") !== -1
  //     ? "http://jmmfapi.cmots.com/api/"
  //     : "http://cmotswebnew:710/api/"
  // );
  // const [BaseURLShare, setBaseURLShare] = useState(
  //   href.indexOf("http://jmmf.cmots.com") !== -1
  //     ? "http://cmotswebnew:710/api/"
  //     : "http://cmotswebnew:710/api/"
  // );

  // Local
  // const [BaseURL, setBaseURL] = useState(
  //   href.indexOf("http://jmmf.cmots.com") !== -1
  //     ? "http://localhost:5218/api/"
  //     : "http://localhost:5218/api/"
  // );
  // const [BaseURLShare, setBaseURLShare] = useState(
  //   href.indexOf("http://jmmf.cmots.com") !== -1
  //     ? "https://jmmfapi.jmfinancialmf.com/api/"
  //     : "https://jmmfapi.jmfinancialmf.com/api/"
  // );

  // Pre Prod
  // const [BaseURL, setBaseURL] = useState(
  //   href.indexOf("http://jmmf.cmots.com") !== -1
  //     ? "http://172.23.10.76:90/api/"
  //     : "http://172.23.10.76:90/api/"
  // );
  // const [BaseURLShare, setBaseURLShare] = useState(
  //   href.indexOf("http://jmmf.cmots.com") !== -1
  //     ? "http://172.23.10.76:90/api/"
  //     : "http://172.23.10.76:90/api/"
  // );
  

  //server uat
  // const [BaseURL, setBaseURL] = useState(href.indexOf('http://jmmf.cmots.com') !== -1 ? 'http://uatjmmfapi.jmfinancialmf.com/api/' : 'http://uatjmmfapi.jmfinancialmf.com/api/');
  // const [BaseURLShare, setBaseURLShare] = useState(href.indexOf('http://jmmf.cmots.com') !== -1 ? 'http://uatjmmfapi.jmfinancialmf.com/api/' : 'http://uatjmmfapi.jmfinancialmf.com/api/');//live url

   // =====================================================
  // API CONFIGURATION
  // =====================================================

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const [BaseURL, setBaseURL] = useState(API_BASE_URL);
  const [BaseURLShare, setBaseURLShare] = useState(API_BASE_URL);



  const [AESkey, setAESkey] = useState(process.env.REACT_APP_AES_KEY || "fallbackKey");
const [AESiv, setAESiv] = useState(process.env.REACT_APP_AES_IV || "fallbackIV");

  return (
    <Context.Provider
      value={{
        ...props,
        BaseURL,
        BaseURLShare,
        setBaseURLShare: setBaseURLShare,
        setBaseURL: setBaseURL,
        AESkey,
        setAESkey: setAESkey,
        AESiv,
        setAESiv: setAESiv,
        fontSize,
        changeFontSize,
        changeFontSizeMinus,
        resetFontSize,
      }}
    >
      {props.children}
    </Context.Provider>
  );
}

export default CommonProvider;